import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, Phone, MapPin, Linkedin, Twitter } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-slate-950 border-t border-slate-800 mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo size={48} />
          <p className="mt-5 text-slate-400 text-sm max-w-sm leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="#"
              data-testid="footer-linkedin"
              className="p-2 border border-slate-800 rounded-sm text-slate-300 hover:text-amber-400 hover:border-amber-500 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={16} />
            </a>
            <a
              href="#"
              data-testid="footer-twitter"
              className="p-2 border border-slate-800 rounded-sm text-slate-300 hover:text-amber-400 hover:border-amber-500 transition-colors"
              aria-label="Twitter"
            >
              <Twitter size={16} />
            </a>
          </div>
        </div>

        <div>
          <div className="font-mono-spec text-xs text-amber-400 mb-4">NAVIGATE</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">{t("nav.about")}</Link></li>
            <li><Link to="/products" className="hover:text-white" data-testid="footer-link-products">{t("nav.products")}</Link></li>
            <li><Link to="/technologies" className="hover:text-white" data-testid="footer-link-technologies">{t("nav.technologies")}</Link></li>
            <li><Link to="/careers" className="hover:text-white" data-testid="footer-link-careers">{t("nav.careers")}</Link></li>
            <li><Link to="/blogs" className="hover:text-white" data-testid="footer-link-blogs">{t("nav.blogs")}</Link></li>
            <li><Link to="/testimonials" className="hover:text-white" data-testid="footer-link-testimonials">{t("nav.testimonials")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-mono-spec text-xs text-amber-400 mb-4">{t("footer.contact_label").toUpperCase()}</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-0.5 text-amber-400" />
              <a href="mailto:support@olivine-global.com" className="hover:text-white" data-testid="footer-email">support@olivine-global.com</a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-0.5 text-amber-400" />
              <a href="tel:+918376008218" className="hover:text-white" data-testid="footer-phone">+91 8376008218</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-0.5 text-amber-400" />
              <span className="text-slate-400">Sector 65, Golf Course Ext. Road,<br />Gurgaon – 122018, India</span>
            </li>
            <li className="pt-2">
              <Link
                to="/admin/login"
                data-testid="footer-admin-link"
                className="text-xs text-slate-500 hover:text-amber-400"
              >
                Admin
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500 font-mono-spec">
        © {year} OLIVINE GLOBAL PVT LTD · {t("footer.rights")}
      </div>
    </footer>
  );
}
